import LandingComponent from "../components/landing/LandingComponent";
import LandingComponent_backup from "../components/landing/LandingComponent_backup";
import LandingLoginComponent from "../components/landing/LandingLoginComponent";

const LandingPage = () => {
	return <LandingComponent />;
	// return <LandingComponent_backup />;
	// return <LandingLoginComponent />;
};

export default LandingPage;
